module.exports = __webpack_public_path__ + "img/main-first.61d708c4.png";